package com.shadowings.gero.data.lessons.chapter2

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.MultiSelectionContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource

fun getNumberGenderContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_per_decifrare_la_scritta_ci_serve_imparare_qu,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_come_in_italiano_i_nomi_si_declinano_per_gene,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_il_genere_pu_essere_maschile_o_femminile,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_il_numero_pu_essere_singolare_plurale_o_duale,
            face = Faces.Surprised,
        ),
        ExplanationContent(
            title = Res.string.exp_title_genere,
            content = Res.string.exp_content_di_norma_un_sostantivo_maschile_se_non_termin,
            face = Faces.Idle,
            composable = {
                MdCWord(
                    word = "X1",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_genere,
            content = Res.string.exp_content_questi_sono_fratello_sn_e_sorella_snt,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-A1",
                        rtl = false,
                        cart = false
                    )
                    Spacer(Modifier.size(8.dp))
                    MdCWord(
                        word = "T22-X1*buco-B1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(
                        word = "G43",
                        rtl = false,
                        cart = false
                    )
                    Spacer(Modifier.size(4.dp))
                    Text(text = stringResource(Res.string.common_or))
                    Spacer(Modifier.size(4.dp))
                    MdCWord(
                        word = "Z7",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_questi_sono_fratelli_snu_e_sorelle_snut,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-G43-A1",
                        rtl = false,
                        cart = false
                    )
                    Spacer(Modifier.size(8.dp))
                    MdCWord(
                        word = "T22-Z7:X1*buco-B1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_a_volte_al_posto_della_u_si_potevano_trovare_,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-Z3A-A1",
                        rtl = false,
                        cart = false
                    )
                    Spacer(Modifier.size(8.dp))
                    MdCWord(
                        word = "T22-Z3A:X1*buco-B1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_i_due_fratelli_snuy,
            face = Faces.Surprised,
            composable = {
                MdCWord(
                    word = "T22-Z7:Z4-A1",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_numero,
            content = Res.string.exp_content_le_due_sorelle_snty,
            face = Faces.Perfect,
            composable = {
                MdCWord(
                    word = "T22-X1*buco:Z4-B1",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_frequentemente_venivano_ripetuti_i_simboli_an,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp,
            face = Faces.Surprised,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-T22-Z7:X1*buco",
                        rtl = false,
                        cart = false
                    )
                }

            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si,
            face = Faces.Sad,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-T22-X1*buco:Z4-B1-B1",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_qui_sempre_per_motivi_artistici_viene_anche_a,
            face = Faces.Cry,
            composable = {
                Column {
                    MdCWord(
                        word = "T22-N35:X1*Z4-I12-I12",
                        rtl = false,
                        cart = false
                    )
                }

            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_insomma_ci_vuole_un_po_di_pratica,
            face = Faces.Surprised,
        ),
        ExplanationContent(
            title = Res.string.exp_title_altri_plurali,
            content = Res.string.exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega,
            face = Faces.Sad,
        ),
        ExplanationContent(
            title = Res.string.exp_title_non_preoccuparti_per_ora,
            content = Res.string.exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo,
            face = Faces.Sad,
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_fine_della_spiegazione,
            face = Faces.Perfect
        )
    )
}

fun getNumberGenderQuizContent(): List<IQuizContent> {
    val quizList = mutableListOf<IQuizContent>()
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_declinazione,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_neutro,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_maschile,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_raddoppiare,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_duale,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_u_plurale,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_uy_femminile,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_number_gender_tre_trattini,
            correct = true
        )
    )
    quizList.add(
        MultiSelectionContent(
            text = Res.string.quiz_number_gender_multi_duale_masc,
            options = listOf(
                Option(Res.string.quiz_number_gender_opt_uy, true),
                Option(Res.string.quiz_number_gender_opt_ripetere, true),
                Option(Res.string.quiz_number_gender_opt_y, false),
                Option(Res.string.quiz_number_gender_opt_tre_trattini, false)
            ).shuffled()
        )
    )
    quizList.add(
        MultiSelectionContent(
            text = Res.string.quiz_number_gender_multi_plurale,
            options = listOf(
                Option(Res.string.quiz_number_gender_opt_u_genere, true),
                Option(Res.string.quiz_number_gender_opt_trovare_trattini, true),
                Option(Res.string.quiz_number_gender_opt_ripetere_simboli, true),
                Option(Res.string.quiz_number_gender_opt_regola_rigida, false)
            ).shuffled()
        )
    )
    return quizList.shuffled()
}